<template>
  <div>
    <span v-if="!datesStrings.length">-</span>

    <date-and-time-display
      v-for="(value, index) in datesStrings"
      :value="value"
      :key="index"
      :class="dateClass"
    />
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";

import { isValid } from "date-fns";

import { formatDateCustom } from "@/helpers/formatting";

import DateAndTimeDisplay from "@/components/ui/text/DateAndTimeDisplay.vue";

const { value, dateClass } = defineProps<{
  value?: string[];
  dateClass: string;
}>();

const datesStrings = computed(() => {
  return (
    value?.map((date) =>
      isValid(new Date(date)) ? formatDateCustom(date) : "-"
    ) ?? []
  );
});
</script>
